import { Col, Container, Row } from "reactstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const Galery = () => {

  const listGalery = [
    { name:"CISWA Awards Spotlight: Louise Hill named WA international VET student of the year", img:"assets/images/gallery/gallery1.webp" },
    { name:"From Papua to Perth: Herlina Yawang's dreams to become an early childhood educator", img:"assets/images/gallery/gallery2.webp" },
    { name:"Apply for CISWA WA International VET Student of the Year 2025", img:"assets/images/gallery/gallery3.webp" },
    { name:"New kitchen facilities at Bentley campus", img:"assets/images/gallery/gallery4.webp" },
    { name:"Careers in nursing and community services", img:"assets/images/gallery/gallery5.webp" },
    { name:"Pursuing his music dreams at NM TAFE: George Kaewniyom", img:"assets/images/gallery/gallery6.webp" },
  ]

  return (
    <section className="section" id="galery">
      <Container>
        <Row className="">
            <LightGallery
              speed={500}
              plugins={[lgThumbnail, lgZoom]}
              selector=".masonry-item"
              download={false}
            >
              <div className="masonry">
                {listGalery.map((item, id) => (
                  <a 
                    key={id} 
                    href={item.img}
                    className="masonry-item"
                  >
                    <img 
                      alt={item.name} 
                      src={item.img} 
                      className="img-fluid" 
                    />
                  </a>  
                ))}      
              </div>            
            </LightGallery>   
        </Row>
      </Container>
    </section>
  );
};

export default Galery;